/**
 * Updates Supabase Auth user_metadata from the signed-in client after the API
 * persisted first/last name. Does not require server-side supabaseAdmin.
 */

import { supabase } from '../../lib/supabase'

export interface SyncDisplayNameToSupabaseSessionParams {
  /** Trimmed string shown as display name (keeps full_name/name in sync). */
  trimmedDisplayName: string
  firstName: string
  lastName?: string
}

export interface SyncDisplayNameToSupabaseSessionResult {
  success: boolean
  message?: string
}

/**
 * Merge display name into session user_metadata (first_name, last_name, full_name, name).
 */
export async function syncDisplayNameToSupabaseSession(
  params: SyncDisplayNameToSupabaseSessionParams
): Promise<SyncDisplayNameToSupabaseSessionResult> {
  const { trimmedDisplayName, firstName, lastName } = params
  const data: Record<string, string | null> = {
    first_name: firstName,
    full_name: trimmedDisplayName,
    name: trimmedDisplayName,
  }
  if (lastName !== undefined && lastName !== '') {
    data.last_name = lastName
  } else {
    data.last_name = null
  }

  const { error } = await supabase.auth.updateUser({ data })
  if (error) {
    return { success: false, message: error.message }
  }
  return { success: true }
}
